import { IVideo } from '../../../repositories/developer-card/entities/developer_special_promo/Video';
import { IApplicationState } from '../../../types/redux';
import { getTemplateSpecialPromo } from './getTemplateSpecialPromo';

export function getTemplateSpecialPromoVideo(state: IApplicationState): IVideo | undefined {
  return getTemplateSpecialPromo(state)?.video ?? undefined;
}
